import { MyAccountContainerProps } from '../../../components/MyAccountContainer/type/propsTypes';
import { CMSTransformerDataType } from '../../types/common';
const transformMyAccountContainer = (data: CMSTransformerDataType): MyAccountContainerProps => {
  const userData = data.items.map((item: CMSTransformerDataType) => ({
    sectionData: {
      iconName: item.icon,
      title: item.title,
      subTitle: item.description,
      link: item.link,
    },
  }));
  const isRenewalUrgent = data.isRenewalUrgent ?? false;
  return {
    componentType: 'my_account_container',
    userData,
    isRenewalUrgent,
  };
};

export default transformMyAccountContainer;
